import React, { useEffect } from "react";
import ApriGiornata from "./ApriGiornata";
import ChiudiGiornata from "./ChiudiGiornata";
import ChiusuraMatch from "./ChiusuraMatch";
import Edizioni from "./Edizioni";
import Headers from "./Header";
import Cache from "./Cache";
import Configurations from "./Configurations";
import Dashboard from "./Dashboard";
import Analytics from "./Analytics";
import Leghe from "./Leghe";
import Notifiche from "./Notifiche";
import axios from "axios";

export default function Homepage(props) {
    const [menuList, setMenuList] = React.useState([])
    const [active, setActive] = React.useState(menuList?.length > 0 ? menuList[0] : 'dashboard');
    useEffect(() => {
        getRules()
    }, [])
    const getRules = () => {
        axios.defaults.headers.common['jwt'] = sessionStorage.getItem('val');
        axios.get(sessionStorage.getItem('env') + "/survivor/api/v1/Admin/getAuthorities").then(function (response) {
            // axios.get('' + "/survivor/api/v1/Admin/getAuthorities").then(function (response) {
            setMenuList(response?.data?.response)
        })

    }
    return (<div>
        <Headers active= { active } setActive = { setActive } menu = { menuList } />

            { active === 'chiudi_match' ? <ChiusuraMatch /> :
                (active === 'chiudi_giornata' ? <ChiudiGiornata />  :
                    (active === 'apri_giornata' ? <ApriGiornata /> :
                        (active === 'edizioni' ? <Edizioni /> :
                            (active === 'analytics' ? <Analytics /> :
                                (active === 'cache' ? <Cache /> :
                                    (active === 'configurations' ? <Configurations /> :
                                        (active === 'leghe' ? <Leghe /> :
                                            (active === 'notifiche' ? <Notifiche /> :
                                                (active === 'dashboard' ? <Dashboard /> : '')))))))))
}
</div>)

}